import { useState } from "react";
import { PaymentMethodsLayout } from "./PaymentMethodsLayout";
import { PaymentMethods } from "./PaymentMethods";
import { AdditionalInfo } from "./AdditionalInfo";

type TListingOption = { label: string, value: 'tab' | 'list' };

export const PaymentsTab = ({ merchantFlags }: { merchantFlags: string[] }) => {

  const [groupPayLater, setGroupPayLater] = useState(false);
  const [listingType, setListingType] = useState<TListingOption>();

  return (
    <>
      <PaymentMethodsLayout
        groupPayLater={groupPayLater}
        setGroupPayLater={setGroupPayLater}
        listingType={listingType}
        setListingType={setListingType}
      />
      <PaymentMethods
        groupPayLater={groupPayLater}
        listingType={listingType?.value}
      />
      <AdditionalInfo merchantFlags={merchantFlags} />
    </>
  )
};